import React, { useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { Calendar, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import BlogNewsletterSignup from '../components/BlogNewsletterSignup';
import { blogPosts } from '../data/mockData';

const BlogPost = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const post = blogPosts.find((p) => p.id === id);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  if (!post) {
    return (
      <div className="min-h-screen flex items-center justify-center pt-32">
        <div className="text-center">
          <h1 className="font-cormorant text-4xl text-navy mb-4">Post Not Found</h1>
          <Button asChild>
            <Link to="/media">Back to Media</Link>
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Image */}
      <div className="pt-20">
        <div className="relative max-h-[600px] overflow-hidden flex items-center justify-center bg-cream">
          <img
            src={post.image}
            alt={post.title}
            className="w-full h-auto max-h-[600px] object-contain"
          />
        </div>
      </div>

      {/* Article Content */}
      <article className="py-16 px-6 lg:px-12 bg-white">
        <div className="container mx-auto max-w-4xl">
          {/* Date */}
          <div className="flex items-center text-xs text-gold font-bold tracking-wider uppercase mb-6 justify-center">
            <Calendar size={14} className="mr-2" />
            {post.date}
          </div>

          {/* Title */}
          <h1 className="font-cormorant text-4xl md:text-5xl lg:text-6xl text-navy mb-8 leading-tight text-center">
            {post.title}
          </h1>

          {/* Content */}
          <div 
            className="blog-content max-w-none text-gray-700"
            dangerouslySetInnerHTML={{ __html: post.content }}
          />

          {/* Newsletter Signup */}
          <BlogNewsletterSignup />

          {/* Back Button */}
          <div className="mt-16 text-center">
            <Button
              variant="outline"
              onClick={() => navigate(-1)}
              className="text-gray-600 hover:text-gold border-2 border-gray-300 hover:border-gold"
            >
              <ArrowLeft size={20} className="mr-2" />
              Back to Media
            </Button>
          </div>
        </div>
      </article>
    </div>
  );
};

export default BlogPost;
